import { Control, FieldErrors, UseFormRegister } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Section } from 'components/Display/Section/Section';
import { Input } from 'components/Form/Input/Input/Input';

import { SsccSettingsFormState } from '../helpers';
import { SerialNumberField } from './SerialNumberField';

type GenerationSectionProps = {
  control: Control<SsccSettingsFormState>;
  register: UseFormRegister<SsccSettingsFormState>;
  errors: FieldErrors<SsccSettingsFormState>['generation'];
  seedable: boolean;
  counterValue: number | null;
  disabled: boolean;
};

export const GenerationSection = ({
  control,
  register,
  errors,
  seedable,
  counterValue,
  disabled,
}: GenerationSectionProps) => {
  const { t } = useTranslation();

  return (
    <Section.Horizontal
      title={t('settings:ssccSettings.generation.title')}
      description={t('settings:ssccSettings.generation.description')}
    >
      <Input
        label={t('settings:ssccSettings.form.gs1Prefix')}
        description={t('settings:ssccSettings.form.gs1PrefixSubtitle')}
        errors={errors?.gs1_prefix}
        disabled={disabled}
        required
        {...register('generation.gs1_prefix')}
      />

      <SerialNumberField
        control={control}
        seedable={seedable}
        counterValue={counterValue}
        error={errors?.counter_seed}
        disabled={disabled}
      />
    </Section.Horizontal>
  );
};
